export const
  HUD_IDS = {
    ACTION_BAR_PLAYER: 'action-bar-player',
    ACTION_BAR_ALPHA_BASE_ENEMY: 'action-bar-alpha-base-enemy',
    ACTION_BAR_RAID_ENEMY: 'action-bar-raid-enemy',
    STATUS_BAR_TOP_LEFT: 'status-bar-top-left',
    STATUS_BAR_TOP_RIGHT_ALPHA_BASE: 'status-bar-top-right-alpha-base',
    STATUS_BAR_TOP_RIGHT_RAID: 'status-bar-top-right-raid'
  }
;